<template>
  <div class="contenedorTablaSinColor">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading
        :active="loader"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>
    <b-row >
      <b-col cols="12"  v-if="!modoEdicion"><!--modo edicion desactivado-->
        <b-table-simple sticky-header responsive>
          <b-thead class="columnasTablaSinColor">
            <b-tr>
              <b-th class="border-top-0" v-for="(field, index) in fields" :key="index">
                {{ field.label }}
              </b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <template v-for="(dato,index) in datosTabla">
              <template v-for="(tx, i) in dato.tratamientos">
                <b-tr :key="'fila'+index+i">
                  <td :rowspan="dato.tratamientos.length * 2" v-if="i === 0">{{ dato.etapa }}</td>
                  <td :rowspan="dato.tratamientos.length * 2" v-if="i === 0">{{ dato.od }}</td>
                  <td :rowspan="dato.tratamientos.length * 2" v-if="i === 0">{{ dato.padecimiento }}</td>
                  <td>
                      {{tx.tratamiento}}
                      <!--Icono de replica y chevron-->
                      <div>
                        <em class="replica_svg mr-2 ml-2" :id="'replica'+tx.idPtiTratamiento" v-if="tx.esReplica || tx.txAgregadoReplica"></em>
                        <b-popover :target="'replica'+tx.idPtiTratamiento" triggers="hover" placement="topright" v-if="tx.esReplica || tx.txAgregadoReplica">
                          Se cambió este tratamiento vía réplica
                        </b-popover>
                        <b-icon icon="chevron-down" v-b-toggle="'collapseDetalleReplica-'+index+i"
                                v-if="tx.esReplica && !tx.replicaProceso"
                                :rotate="rotarChevron['collapseDetalleReplica-'+index+i] ? 180 : 0"
                                @click="rotar('collapseDetalleReplica-',index, i)"></b-icon>
                      </div>
                      <!--Icono de proceso en replica-->
                      <div v-if="tx.replicaProceso">
                        <em class="en_espera_svg mr-2 ml-2" :id="'replica'+tx.idPtiTratamiento" v-b-popover.hover.bottomright="'Tratamiento en proceso de réplica'"></em>
                      </div>
                  </td>
                  <td>
                      {{tx.cantidad}}
                  </td>
                  <td>
                      <div v-for="estatus in opcionesEstatus" :key="estatus.idEstatusPtiTratamiento">
                    <span v-if="estatus.idEstatusPtiTratamiento === tx.idEstatus">
                      {{ estatus.descripcion }}
                    </span>
                      </div>
                  </td>
                  <td>
                      {{ tx.montoPagar | monedaSinDecimal }}
                      <b-icon icon="chevron-down"
                              v-b-toggle="'collapseDetallePrecio-'+index+i"
                              :rotate="rotarChevron['collapseDetallePrecio-'+index+i] ? 180 : 0"
                              @click="rotar('collapseDetallePrecio-',index, i)">
                      </b-icon>
                  </td>
                </b-tr>
                <b-tr :key="'collapseDetalle-' + index+i">
                  <b-td colspan="4" class="detalle">
                    <b-collapse v-if="tx.esReplica" :id="'collapseDetalleReplica-' + index+i" :accordion="'my-accordion' + index+i">
                      <div class="contenedorTablaSinColor text-left m-2 p-2">
                        <p class="m-1"><strong>{{ tx.tratamiento }}</strong></p>
                        <p class="m-1">Cambio de tratamiento via réplica</p>
                        <p class="m-1">Tratamiento anterior: {{ tx.txAnterior }}</p>
                        <p class="m-1">Usuario que modificó: {{ tx.usuarioModifico }}</p>
                      </div>
                    </b-collapse>
                    <b-collapse v-if="!modoEdicion" :id="'collapseDetallePrecio-' + index+i" :accordion="'my-accordion' + index+i">
                      <div class="contenedorTablaPrecio text-left m-2 p-2">
                        <b-table-simple class="text-center">
                          <b-thead style="color: #7cb92e">
                            <b-tr>
                              <b-th>Precio unitario</b-th>
                              <b-th>Descuento por plan %</b-th>
                              <b-th>Descuento por promoción %</b-th>
                              <b-th>Inversión</b-th>
                            </b-tr>
                          </b-thead>
                          <b-tbody>
                            <b-tr>
                              <b-td>{{ tx.precioUnitario | monedaSinDecimal }}</b-td>
                              <b-td>{{ tx.descuentoPlan }}%</b-td>
                              <b-td>
                                <tag-promocion v-if="!tx.tienePromocionAplicada && tx.promocion == null && tx.montoPagar > 0"      :promociones.sync="promociones"
                                               :tratamiento.sync="tx">
                                </tag-promocion>
                                <p class="letrasChiquitas mt-1" v-if="tx.promocion != null">
                                  {{ tx.promocion.promocion}}
                                  <em v-if="tx.promocion.promocionForzosa == false" class="fa fa-close botoncito" @click="quitarPromo(tx)"></em>
                                  <em class="cupon_svg sm" style="filter: invert(67%) sepia(21%) saturate(6798%) hue-rotate(341deg) brightness(97%) contrast(84%) !important;"></em>
                                  <em class="fa fa-solid fa-tag" style="color: red !important;"/>
                                </p>
                                <p  class="letrasChiquitas mb-0" v-if="tx.tienePromocionAplicada">
                                  <span v-if="tx.idCupon != null">
                                    Cupón -
                                    <span v-if="tx.descuentoCupon !== null">
                                      {{ tx.descuentoCupon + '%' }}
                                    </span>
                                    <span v-else>
                                      {{ '$ ' + tx.montoCupon }}
                                    </span>
                                    <em class="cupon_svg sm" style="filter: invert(67%) sepia(21%) saturate(6798%) hue-rotate(341deg) brightness(97%) contrast(84%) !important;"></em>
                                  </span>
                                  <span v-else-if="tx.idPromocion !== null">
                                    Promoción - <span>({{ tx.descuentoPromocion + "%" }})</span>
                                    <em class="fa fa-solid fa-tag" style="color: red !important;"/>
                                  </span>
                                </p>
                                <span v-else>
                                    0%
                                </span>
                              </b-td>
                              <b-td>
                                <span v-if="tx.promocion != null">{{Math.ceil(tx.montoPagar -(( tx.montoPagar)*(tx.promocion.descuento /100)))   | moneda }}</span><span v-else>{{ tx.montoPagar | moneda }}</span>
                              </b-td>
                            </b-tr>
                          </b-tbody>
                        </b-table-simple>
                      </div>
                    </b-collapse>
                  </b-td>
                </b-tr>
              </template>
            </template>
          </b-tbody>
        </b-table-simple>
        <div align="center" v-if="loader">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
        <b-col v-if="!loader">
          <b-alert v-if="datosTabla === null || datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
        </b-col>
      </b-col>

      <b-col cols="12"  v-if="modoEdicion">
        <b-table-simple sticky-header responsive>
          <b-thead class="columnasTablaSinColor">
            <b-tr>
              <b-th class="border-top-0">Detalle PTI</b-th>
              <b-th class="border-top-0">Órgano dental afectado</b-th>
              <b-th class="border-top-0">Padecimiento</b-th>
              <b-th class="border-top-0">Tratamiento / Condición clínica</b-th>
              <b-th class="border-top-0">Cantidad</b-th>
              <b-th class="border-top-0">Estatus de Pago</b-th>
              <b-th class="border-top-0">Estatus</b-th>
              <b-th class="border-top-0">Acciones</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <template v-for="(dato,index) in datosTablaNuevos">
              <template v-for="(tx, i) in dato.tratamientos">
                <b-tr :key="'fila'+index+i">
                  <b-td :rowspan="dato.tratamientos.length * 2" v-if="i === 0">
                    <validation-provider
                      :name="etapa"
                      :rules="{ required: true }"
                      v-slot="etapaSlot"
                    >
                      <v-select
                        v-model="dato.etapa"
                        :options="etapasFiltro"
                        :filterable="false"
                        @search="filtroEtapas"
                        label="descripcion"
                        :reduce="(variable) => variable.descripcion"
                        @input="etapaSeleccionada(dato)"
                      >
                      </v-select>
                      <validacion
                        :texto="etapaSlot.errors[0] ? etapaSlot.errors[0] : ''"
                      ></validacion>
                    </validation-provider>
                  </b-td>
                  <b-td :rowspan="dato.tratamientos.length * 2" v-if="i === 0">
                    <validation-provider
                      :name="diente"
                      :rules="{ required: true }"
                      v-slot="dienteSlot"
                    >
                      <v-select
                        v-model="dato.od"
                        :options="listaDientes"
                        :filterable="false"
                        @input="dienteSeleccionado(dato)"
                      >
                      </v-select>
                      <validacion
                        :texto="dienteSlot.errors[0] ? dienteSlot.errors[0] : ''"
                      ></validacion>
                    </validation-provider>
                  </b-td>
                  <b-td :rowspan="dato.tratamientos.length * 2" v-if="i === 0">
                    <validation-provider
                      :name="padecimiento"
                      :rules="{ required: true }"
                      v-slot="padecimientoSlot"
                    >
                      <v-select
                        :options="arrayPadecimientoFiltro"
                        v-model="dato.padecimiento"
                        :filterable="false"
                        @search="filtroPadecimiento"
                        label="nombre"
                        :reduce="(variable) => variable.nombre"
                        @input="padecimientoSeleccionado(dato.padecimiento, index)"
                      >
                      </v-select>
                      <validacion
                        :texto="padecimientoSlot.errors[0] ? padecimientoSlot.errors[0] : ''"
                      ></validacion>
                    </validation-provider>
                  </b-td>
                  <b-td>
                    <div style="text-align: right;" v-if="i === 0">
                      <b-button class="pr-0"
                        variant="link"
                        @click="agregarTratamiento(dato.tratamientos, dato.idEtapa)">
                        <em class="masEditar_svg"
                          style="cursor:pointer;"
                          v-b-popover.hover.topright="'Agregar tratamientos'"
                        />
                      </b-button>
                      <b-button class="pl-0" v-if="editarEtapa == false"
                          variant="link"
                          @click="editarEtapaTratamiento(true)">
                          <em class="engrane_svg"
                            style="cursor: pointer"
                            v-b-popover.hover.topright="'Ver etapas de tratamientos'"
                          />
                      </b-button>
                      <b-button class="pl-0" v-if="editarEtapa == true"
                          variant="link"
                          @click="editarEtapaTratamiento(false)">
                          <em class="engrane_svg"
                            style="cursor: pointer"
                            v-b-popover.hover.topright="'Ocultar etapas de tratamientos'"
                          />
                      </b-button>
                    </div>
                    <div class="row" style="width: 100%;">
                      <validation-provider
                        :name="'validacioncausa' + observaciones"
                        :rules="{ required: true }"
                        v-slot="observacionesSlot"
                        style="width: 80%;"
                      >
                        <v-select  class="ml-2"
                          v-if="editarEtapa == false"
                          style="width: 95%;"
                          :options="arrayTratamientoFiltro"
                          v-model="tx.idTratamiento"
                          :filterable="false"
                          @search="filtroTratamiento"
                          label="nombre"
                          :reduce="(variable) => variable.idTratamiento"
                          @input="tratamientoSeleccionado(tx.idTratamiento, index, i)"
                        >
                        </v-select>
                        <validacion
                          :texto="observacionesSlot.errors[0] ? observacionesSlot.errors[0] : ''"
                        ></validacion>
                      </validation-provider>
                      <b-button class="pl-0 pr-0" v-if="dato.tratamientos.length > 1 && editarEtapa == false" size="md" v-b-tooltip.hover title="Eliminar Tratamiento"
                          style="color: red !important;" variant="link"
                          @click="eliminarTratamiento(dato.tratamientos, tx)">
                        <font-awesome-icon icon="times-circle"/>
                      </b-button>
                      <em v-if="tx.idEstatus !== 5 "
                      class="precio_verde_svg mt-2 ml-1" style="height: 17px; width: 17px;" 
                      v-b-popover.hover.topright="'Ver precios del tratamiento'"
                      v-b-toggle="'collapseDetallePrecio-'+index+i"></em>
                    </div>
                    <div class="ml-3 mr-1" v-if="editarEtapa" style="text-align: left;">
                        <p style="font-size: 12px; font-weight: bold;">Tratamiento: {{ tx.tratamiento }}</p>
                        <validation-provider
                          :name="'validacioncausa' + etapat"
                          :rules="{ required: true }"
                          v-slot="etapatSlot"
                          style="width: 80%;"
                        >
                        <v-select
                          v-model="tx.etapa"
                          :options="etapasFiltro"
                          :filterable="false"
                          @search="filtroEtapas"
                          label="descripcion"
                          :reduce="(variable) => variable.descripcion"
                          @input="etapaSeleccionadaTrt(tx)"
                        >
                        </v-select>
                          <validacion
                            :texto="etapatSlot.errors[0] ? etapatSlot.errors[0] : ''"
                          ></validacion>
                        </validation-provider>
                    </div>
                  </b-td>
                  <b-td>
                    <b-form-input
                      class="redondeo mr-3"
                      id="cantidad"
                      @keypress="onlyNumber($event)"
                      v-model.number="tx.cantidad"
                      type="number"
                      :min="1"
                      pattern="^[0-9]+"
                    ></b-form-input>
                  </b-td>
                  <b-td :rowspan="dato.tratamientos.length * 2" v-if="i === 0">{{ tx.estatusPago }}</b-td>
                  <b-td :rowspan="dato.tratamientos.length * 2" v-if="i === 0">
                    <div>
                      <div v-for="estatus in opcionesEstatus" :key="estatus.idEstatusPtiTratamiento">
                        <div v-if="estatus.idEstatusPtiTratamiento === tx.idEstatus" :style="tx.estatusOrignal === 5 ?'color: #a9a9a9':''">
                          {{ estatus.descripcion }}
                        </div>
                      </div>
                    </div>
                  </b-td>
                  <b-td :rowspan="dato.tratamientos.length * 2" v-if="i === 0">
                    <b-button variant="danger"
                      size="sm"
                      class="marginbotones paddingbotones"
                      @click="eliminarNuevoTratamiento(index)"
                    >
                      <em class="eliminar_svg icon-boton" style=" position: relative; left: 0.5px;"></em>
                    </b-button>
                  </b-td>
                </b-tr>
                <b-tr :key="'collapseDetallePrecio-' + index +i">
                  <b-td :colspan="2" class="detalle">
                    <b-collapse v-if="modoEdicion" :id="'collapseDetallePrecio-' +index+i" :accordion="'my-accordion' + index+i">
                      <div class="contenedorTablaPrecio text-center m-1 p-1">
                        <b-row class="ml-2 mb-0 mt-1">
                          <p style="color: #7cb92e; font-size: 14px; font-weight: bold; text-align: left;">Precio unitario  </p> <p class="ml-1" style="font-size: 14px;">{{ tx.precio | monedaSinDecimal }}</p>
                        </b-row>
                        <b-row class="ml-2 mb-0">
                          <p style="font-size: 11px; font-style: italic;">Podrás ver los descuentos de plan y promoción en lapresentación.</p>
                        </b-row>
                      </div>
                    </b-collapse>
                  </b-td>
                </b-tr>
              </template>
            </template>
            <template v-for="(dato,index) in datosTabla">
              <template v-for="(tx, i) in dato.tratamientos">
              <b-tr :key="'fila'+index+i">
                <b-td :rowspan="dato.rowspan" v-if="i === 0">{{ dato.etapa }}</b-td>
                <b-td :rowspan="dato.rowspan" v-if="i === 0">{{ dato.od }}</b-td>
                <b-td :rowspan="dato.rowspan" v-if="i === 0">{{ dato.padecimiento }}</b-td>
                <b-td :rowspan="2" :colspan="3" v-if="i > dato.filas"></b-td>
                <b-td :style="tx.estilos + 'border-radius: 30px 0px 0px 30px; margin-bottom: 17px; margin-top: 17px'">
                  <div>
                    <!--<div :style="tx.estilos + 'border-radius: 30px 0px 0px 30px; margin-bottom: 17px; margin-top: 17px'">-->
                    <div :style="tx.estatusOrignal === 5 ?'color: #a9a9a9':''">
                    {{ tx.tratamiento }}
                    </div>
                    <!--Icono de replica y chevron-->
                    <div v-if="tx.esReplica || tx.txAgregadoReplica">
                      <em class="replica_svg mr-2 ml-2" :id="'replica'+tx.idPtiTratamiento"
                          v-if="tx.esReplica || tx.txAgregadoReplica"></em>
                      <b-popover :target="'replica'+tx.idPtiTratamiento" triggers="hover" placement="topright"
                                 v-if="tx.esReplica || tx.txAgregadoReplica">
                        Se cambió este tratamiento vía réplica
                      </b-popover>
                      <b-icon icon="chevron-down" v-b-toggle="'collapseDetalleReplica-'+index+i"
                              v-if="tx.esReplica && !tx.replicaProceso"></b-icon>
                    </div>
                    <!--Icono de proceso en replica-->
                    <div v-if="tx.replicaProceso">
                      <em class="en_espera_svg mr-2 ml-2" :id="'replica'+tx.idPtiTratamiento"
                          v-b-popover.hover.bottomright="'Tratamiento en proceso de réplica'"></em>
                    </div>
                    <b-collapse v-if="tx.esReplica" :id="'collapseDetalleReplica-' + index+i"
                                :accordion="'my-accordion' + index+i">
                      <div class="contenedorTablaSinColor text-left m-2 p-2">
                        <p class="m-1"><strong>{{ tx.tratamiento }}</strong></p>
                        <p class="m-1">Cambio de tratamiento via réplica</p>
                        <p class="m-1">Tratamiento anterior: {{ tx.txAnterior }}</p>
                        <p class="m-1">Usuario que modificó: {{ tx.usuarioModifico }}</p>
                      </div>
                    </b-collapse>
                    <!--<hr>-->
                  </div>
                </b-td>
                <b-td :style="tx.estilos">
                  <div :style="tx.estatusOrignal === 5 ?'color: #a9a9a9':''">
                    {{tx.cantidad}}
<!--                    <hr>-->
                  </div>
                </b-td>
                <b-td :style="tx.estilos">
                  <div :style="tx.estatusOrignal === 5 ?'color: #a9a9a9':''">
                    {{tx.estatusPago}}
<!--                    <hr>-->
                  </div>
                </b-td>
                <b-td :style="tx.estilos + 'border-radius: 0px 30px 30px 0px;'">
                    <div v-if="(tx.idEstatus === 1 || tx.idEstatus === 3 || (tx.idEstatus === 5 && tx.estatusOrignal === 5)  || tx.idEstatus === 6 || tx.estatusPago == 'PAGADO' || tx.estatusPago == 'PAGO PARCIAL' || (tx.idEstatus == 4 && tx.registroActivo == false))">
                      <div v-for="estatus in opcionesEstatus" :key="estatus.idEstatusPtiTratamiento">
                        <div v-if="estatus.idEstatusPtiTratamiento === tx.idEstatus" :style="tx.estatusOrignal === 5 ?'color: #a9a9a9':''">
                          {{ estatus.descripcion }}
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <b-form-select v-model="tx.idEstatus"
                                     :options="opcionesEstatus.filter(e=>e.idEstatusPtiTratamiento === 2 ||e.idEstatusPtiTratamiento === 4 ||e.idEstatusPtiTratamiento === 5)"
                                     value-field="idEstatusPtiTratamiento"
                                     text-field="descripcion"
                                     size="sm"
                                     @input="modicoFila($event, tx)"></b-form-select>
<!--                      <hr>-->
                    </div>
                </b-td>
                <b-td >

                    <em v-if="tx.estatusOrignal === 2 && (tx.estatusPago !== 'PAGADO' && tx.estatusPago !== 'PAGO PARCIAL') && !tx.editado && $localStorageService.can('BT_cambiar_Tx_pti')"
                        class="editar_trt_svg" style="left: 13px; top: 12px; width: 32%;"
                        v-b-popover.hover.topright="'Cambio de tratamiento'"
                        @click="pasarDatos(tx.cambiosTratamiento, tx.idPtiTratamiento, dato.etapa),
                        dividirColumna(i, dato, dato.tratamientos.length * 3, dato.tratamientos.length - 1)"
                        v-b-toggle="'collapseCambioTrt-'+index+i"></em>


                    <em v-if="tx.idEstatus !== 5 "
                        class="precioE_svg" style="position: relative; left: 5px; top: 6px; width: 40%;"
                        v-b-popover.hover.topright="'Ver precios del tratamiento'"
                        v-b-toggle="'collapseDetallePrecioAcciones-'+index+i"></em>

                </b-td>
              </b-tr>



<!--                FILA PARA EL DETALLE DE LOS PRECIOS-->
              <b-tr :key="'collapseDetallePrecioAcciones-' + index+i">
                <b-td :colspan="modoEdicion ? 5:4" class="detalle">

                  <b-collapse v-if="dato.esReplica" :id="'collapseDetalleReplica-' + index+i" :accordion="'my-accordion' + index+i">
                    <div class="contenedorTablaSinColor text-left m-2 p-2">
                      <p class="m-1"><strong>{{ dato.tratamiento }}</strong></p>
                      <p class="m-1">Cambio de tratamiento via réplica</p>
                      <p class="m-1">Tratamiento anterior: {{ dato.txAnterior }}</p>
                      <p class="m-1">Usuario que modificó: {{ dato.usuarioModifico }}</p>
                    </div>
                  </b-collapse>


                  <b-collapse v-if="modoEdicion" :id="'collapseDetallePrecioAcciones-' +index+i" :accordion="'my-accordion' + index+i">
                    <div class="contenedorTablaPrecio text-left m-2 p-2">
                      <b-table-simple class="text-center">
                        <b-thead style="color: #7cb92e">
                          <b-tr>
                            <b-th>Precio unitario</b-th>
                            <b-th>Descuento por plan %</b-th>
                            <b-th>Descuento por promoción %</b-th>
                            <b-th>Inversión</b-th>
                          </b-tr>
                        </b-thead>
                        <b-tbody>
                          <b-tr>
                            <b-td>{{ tx.precioUnitario | monedaSinDecimal }}</b-td>
                            <b-td>{{ tx.descuentoPlan }}%</b-td>
                            <b-td>
                              <tag-promocion v-if="!tx.tienePromocionAplicada && tx.promocion == null && tx.montoPagar > 0"  :promociones.sync="promociones"
                                             :tratamiento.sync="tx">
                              </tag-promocion>
                              <p class="letrasChiquitas mt-1" v-if="tx.promocion != null">{{ tx.promocion.promocion}}
                                <em v-if="tx.promocion.promocionForzosa == false" class="fa fa-close botoncito" @click="quitarPromo(tx)"></em></p>
                            </b-td>
                            <b-td>
                              <span v-if="tx.promocion != null">{{Math.ceil(tx.montoPagar -(( tx.montoPagar)*(tx.promocion.descuento /100)))   | moneda }}</span><span v-else>{{ tx.montoPagar | moneda }}</span>
                            </b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>
                    </div>
                  </b-collapse>

                </b-td>

              </b-tr>

              <b-tr :key="'collapseCambioTrt-' + index+i">
                <b-td :colspan="modoEdicion ? 8:4" class="detalle">
                  <b-collapse v-if="modoEdicion && !tx.editado " :id="'collapseCambioTrt-' +index+i" :accordion="'my-accordion-tx'" >
                    <div class="contenedorTablaPrecio text-left m-1 p-2" style="background: #f7f7f7d6">
                      <strong style="color: #1b81af; font-size: 10px; "> Cambio de tratamiento "{{ tx.tratamiento }}"</strong>
                      <b-row>
                        <b-col cols="12" class="ml-4">

                          <b-table-simple class="text-left">

                            <b-tbody>
                              <template v-for="(lst, ind) in tx.cambiosTratamiento" >
                                <b-tr :key="'filaLst'+ind+index">
                                  <b-td style="width: 50%">
                                    <div style=" position: relative; left: 87%;">
                                      <em class="masEditar_svg"
                                          style="cursor:pointer;"
                                          v-b-popover.hover.topright="'Agregar tratamiento'"
                                          @click="agregarNuevo(tx.cambiosTratamiento, tx.idPtiTratamiento, dato.etapa)"
                                      />
                                      <em class="engrane_svg"
                                          style="cursor: pointer"
                                          v-b-popover.hover.topright="'Editar etapa'"
                                          @click="editarEtapa ? editarEtapa = false : editarEtapa = true"
                                      />
                                    </div>
                                    <span v-if="lst.tratamiento !== null"> Tratamiento: {{lst.tratamiento}} </span>
                                    <div class="row">
                                      <validation-provider
                                        :name="etapa"
                                        :rules="{ required: true }"
                                        v-slot="etapaSlot"
                                        style="width: 90%;"
                                      >
                                      <v-select v-if="!editarEtapa"
                                        v-model="lst.idTratamiento"
                                        class="redondeo"
                                        @search="filtroTratamiento"
                                        label="nombre"
                                        id="nombreTrt"
                                        :reduce="(val) => val.idTratamiento"
                                        :options="arrayTratamientoFiltro"
                                        placeholder="Selecciona un tratamiento"
                                        :clearable="false"
                                        @input="ponerNombre(lst, lst.idTratamiento, dato.etapa)"
                                        style="width: 100%;"
                                      />
                                      
                                      <v-select v-else
                                        v-model="lst.etapa"
                                        :options="etapasFiltro"
                                        class="redondeo mr-0 pr-0"
                                        @search="filtroEtapas"
                                        label="descripcion"
                                        id="nombreEtapa"
                                        :reduce="(variable) => variable.idEtapaM2"
                                        placeholder="Selecciona una etapa"
                                        :clearable="false"
                                        style="width: 100%;"
                                      />
                                        <validacion
                                          :texto="etapaSlot.errors[0] ? etapaSlot.errors[0] : ''"
                                        ></validacion>
                                      </validation-provider>
                                      <b-button  size="sm" v-b-popover.hover.topright="'Eliminar tratamiento'"
                                        style="color: red !important; " variant="link"
                                        @click="eliminarTratamientoEdicion(tx.cambiosTratamiento, lst)"
                                        v-if="tx.cambiosTratamiento.length > 1"
                                      >
                                        <font-awesome-icon icon="times-circle"/>
                                      </b-button>
                                      <em v-if="tx.idEstatus !== 5 "
                                        class="precio_verde_svg mt-2 ml-2" style="height: 15px; width: 15px;" 
                                        v-b-popover.hover.topright="'Ver precios del tratamiento'"
                                        v-b-toggle="'collapseDetallePrecioEdicion-'+ind+index">
                                      </em>
                                    </div>
                                  </b-td>
                                  <b-td class="pl-4" style="width: 2%">
                                    <b-form-input
                                        class="redondeo mr-3"
                                        id="cantidad"
                                        @keypress="onlyNumber($event)"
                                        v-model.number="lst.cantidad"
                                        type="number"
                                        :min="1"
                                        pattern="^[0-9]+"
                                    ></b-form-input>
                                  </b-td>
                                  <b-td style="text-align: center; width: 8%;">{{tx.estatusPago}}</b-td>
                                  <b-td style="width: 12%;">
                                    <div v-for="estatus in opcionesEstatus" :key="estatus.idEstatusPtiTratamiento" style="text-align: center;">
                                      <div v-if="estatus.idEstatusPtiTratamiento === tx.idEstatus" :style="tx.estatusOrignal === 5 ?'color: #a9a9a9':''">
                                        {{ estatus.descripcion }}

                                        <b-button variant="danger"
                                                  size="sm"
                                                  class="marginbotones paddingbotones ml-2 mr-5"
                                                  style="position: relative; left: 18%;"
                                                  v-b-popover.hover.topright="'Quitar replica(s)'"
                                                  @click="quitarReplicas(tx.cambiosTratamiento, ind)"
                                        >
                                          <em class="eliminar_svg icon-boton" ></em>
                                        </b-button>
                                      </div>

                                    </div>



                                  </b-td>
                                </b-tr>
                                <b-tr :key="'collapseDetallePrecioEdicion-' +ind+index">
                                  <b-td class="detalle mr-0 pr-0" style="width: 20%;">
                                    <b-collapse v-if="modoEdicion" :id="'collapseDetallePrecioEdicion-' +ind+index" :accordion="'my-accordion' + +ind+index">
                                      <div class="contenedorTablaPrecio text-center">
                                        <b-row class="ml-2 mb-0 mt-1">
                                          <p style="color: #7cb92e; font-size: 14px; font-weight: bold; text-align: left;">Precio unitario </p> <p class="ml-1" style="font-size: 14px;"> {{ tx.cambiosTratamiento[ind].precio | monedaSinDecimal }}</p>
                                        </b-row>
                                        <b-row class="ml-2 mb-0">
                                          <p style="font-size: 11px; font-style: italic;">Podrás ver los descuentos de plan y promoción en lapresentación.</p>
                                        </b-row>
                                      </div>
                                    </b-collapse>
                                  </b-td>
                                </b-tr>
                              </template>
                            </b-tbody>
                          </b-table-simple>

                        </b-col>
                      </b-row>

                    </div>
                  </b-collapse>
                </b-td>
              </b-tr>
              </template>
            </template>
          </b-tbody>
        </b-table-simple>
        <div align="center" v-if="loader">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
        <b-col v-if="!loader">
          <b-alert v-if="datosTabla === null || datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import TagPromocion from "../../components/promocion/TagPromocion";
import {PromocionesService} from "@/apiServices/promociones/PromocionesService";
import {ValidationProvider} from 'vee-validate'
export default {
  name: "PTIActual",
  components: {TagPromocion, ValidationProvider},
  data:()=>{
    return{
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      fields:[
        {key: "etapa", label:"Detalle PTI", sortable: true},
        {key: "od", label:"Organo Dental Afectado", sortable: true},
        {key: "padecimiento", label:"Padecimiento", sortable: true},
        {key: "tratamiento", label:"Tratamiento / Condición clínica", sortable: true},
        {key: "cantidad", label:"Cantidad", sortable: true},
        {key: "idEstatus", label:"Estatus", sortable: true},
        {key: "montoPagar", label:"Precio", sortable: true}
      ],

      pti:{
        detallePti:null,
        organoDental: null,
        padecimiento: null,
        tratamiento: null,
        cantidad: null
      },


      paginaActual: 0,
      detalleFila: 1,

      ocultar: true,
      promocionesServicio: new PromocionesService(),
      promociones:[],
      opcionAceptada:1,
      rotarChevron: [],
      editarEtapa: false,
      editarEtapaCambioTrt: false,
      listaTratamientosCambiados:[{
        tratamiento: null,
        idTratamiento: null,
        etapa: 3,
        cantidad: 1,
      }],
      filaCambioTxActual: -1
    }
  },
  props: {
    datosTabla: Array,
    datosTablaNuevos: Array,
    loader: Boolean,
    modoEdicion: Boolean,
    opcionesEstatus: Array,
    idPti:Number,
    opcionAceptadaHistorial:Number,
    arrayTratamiento: Array,
    arrayTratamientoFiltro: Array,
    arrayPadecimiento: Array,
    arrayPadecimientoFiltro: Array,
    listaDientes: Array,
    arrayDiente: Array,
    etapasFiltro: Array,
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.loader = true;
    this.obtenerPromociones();
  },

  methods:{
    entrarModoEdicion() {
      this.loader = true;
      this.fields = [
        {key: "etapa", label:"Detalle PTI", sortable: true},
        {key: "od", label:"Organo Dental Afectado", sortable: true},
        {key: "padecimiento", label:"Padecimiento", sortable: true},
        {key: "tratamiento", label:"Tratamiento / Condición clínica", sortable: true},
        {key: "cantidad", label:"Cantidad", sortable: true},
        {key: "estatusPago", label:"Estatus de pago", sortable: true},
        {key: "idEstatus", label:"Estatus", sortable: true},
        {label: "Acciones"}
      ];
      this.loader = false;
    },
    salirModoEdicion() {
      this.fields = [
        {key: "etapa", label:"Detalle PTI", sortable: true},
        {key: "od", label:"Organo Dental Afectado", sortable: true},
        {key: "padecimiento", label:"Padecimiento", sortable: true},
        {key: "tratamiento", label:"Tratamiento / Condición clínica", sortable: true},
        {key: "cantidad", label:"Cantidad", sortable: true},
        {key: "idEstatus", label:"Estatus", sortable: true},
        {key: "montoPagar", label:"Precio", sortable: true}
      ];

      this.datosTabla.forEach(obj => {
        if (obj.editado === true) {
          obj.editado = false;
          obj.estilos = '';
        }
      })
    },
    modicoFila(idEstatus, tx) {
      if(idEstatus !== tx.estatusOrignal){
      tx.editado = true
      if (idEstatus === 4) {
        tx.estilos = 'background-color: #ffc794; border-bottom: 7px solid #ffffff;'
      } else if (idEstatus === 2) {
        tx.estilos = 'background-color: #cdf5c6; border-bottom: 7px solid #ffffff;';
      } else if (idEstatus === 5) {
        tx.estilos = 'background-color: #ffbcc0; border-bottom: 7px solid #ffffff;';
      } else {
        tx.estilos = '';
      }
      }else{
        tx.editado = false;
        tx.estilos = '';
      }
    },
    obtenerPromociones(){
      this.loader = true;
      const fecha = this.$moment(new Date()).format('DD/MM/YYYY');
      const datos = {
        fecha: fecha,
        idClinica: this.$localStorageService.getIdClinica(),
        idPti: this.idPti,
        opcio: this.opcionAceptada
      }
      this.promocionesServicio.obtenerPromocionesPorPtiParaSDI(datos)
          .then(respuesta => {
            this.promociones = respuesta
            this.loader = false;
          })
    },
    quitarPromo(item){
      this.promociones.forEach( p => {
        if (p.idPromocion === item.promocion.idPromocion){
          p.seleccionado = false;
        }
      })
      item.promocion = null
    },
    rotar(id, index, i) {
      let idChevron = id + index + i;
      this.$set(this.rotarChevron, idChevron, !this.rotarChevron[idChevron]);
      if (idChevron.includes('collapseDetalleReplica')) {

        if (this.rotarChevron['collapseDetalleReplica-'+index + i] &&
            this.rotarChevron['collapseDetallePrecio-'+index + i]) {
          this.rotarChevron['collapseDetallePrecio-'+index + i] = !this.rotarChevron['collapseDetallePrecio-'+index + i]
        }

      } else if (idChevron.includes('collapseDetallePrecio')) {

        if (this.rotarChevron['collapseDetallePrecio-'+index + i] &&
            this.rotarChevron['collapseDetalleReplica-'+index + i]) {
          this.rotarChevron['collapseDetalleReplica-'+index + i] = !this.rotarChevron['collapseDetalleReplica-'+index + i]
        }

      }
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
    filtroEtapas(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.etapasFiltro = this.etapas.filter(em => {
        return em.descripcion.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    etapaSeleccionada(item) {
      let id = 0;
      if(item.etapa != null){
        id = this.etapasFiltro.find(e=> e.descripcion == item.etapa);
        item.idEtapa = id.idEtapaM2;
        item.tratamientos.map(tx => {
          tx.idEtapa = id.idEtapaM2;
          tx.etapa = id.descripcion;
          tx.editarEtapaManual = false;
        })
      }else{
        item.idEtapa = null;
      }
    },
    etapaSeleccionadaTrt(item) {
      let id = 0;
      if(item.etapa != null){
        id = this.etapasFiltro.find(e=> e.descripcion == item.etapa)
        item.idEtapa = id.idEtapaM2;
        item.etapa = id.descripcion;
      }else{
        item.idEtapa = null;
        item.etapa = null;
      }
      item.editarEtapaManual = true;
    },
    dienteSeleccionado(item) {
      if(item.od>0){
        this.arrayDiente.forEach(d => {
          if(d.numeroDiente === item.od){
            item.idDiente = d.idDiente;
          }
        });
      }else{
        if(item.od != null){
          let diente = item.od.split("-");
          this.arrayDiente.forEach(d => {
            if(d.nombre === diente[1]){
              item.idDiente = d.idDiente;
            }
          });
        }else{
          item.idDiente = null;
        }
      }
    },
    filtroPadecimiento(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.arrayPadecimientoFiltro = this.arrayPadecimiento.filter(em => {
        return em.nombre.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroTratamiento(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.arrayTratamientoFiltro = this.arrayTratamiento.filter(em => {
        return em.nombre.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    agregarTratamiento(lista, etapa) {
      lista.push({
        idTratamiento: null,
        idEtapa: etapa,
        cantidad: 1,
        estatusPago: "NO PAGADO",
        idEstatus: 2,
      })
    },
    eliminarTratamiento(lista, item) {
      lista.splice(lista.indexOf(item), 1);
    },
    tratamientoSeleccionado(item, index, i){
      let nombre = "";
      nombre = this.arrayTratamientoFiltro.find(t=> t.idTratamiento == item);
      if(item != null){
        this.datosTablaNuevos[index].tratamientos[i].tratamiento = nombre.nombre;
        this.datosTablaNuevos[index].tratamientos[i].precio = nombre.precio;
      }else{
        this.datosTablaNuevos[index].tratamientos[i].tratamiento = null;
        this.datosTablaNuevos[index].tratamientos[i].precio = null;
      }
    },
    padecimientoSeleccionado(item, index){
      let id = null;
      if(item != null){
        id = this.arrayPadecimientoFiltro.find(t=> t.nombre == item);
        this.datosTablaNuevos[index].idPadecimiento = id.idPadecimento;
      }else{
        this.datosTablaNuevos[index].idPadecimiento = null;
      }
    },
    eliminarNuevoTratamiento(index){
      this.datosTablaNuevos.splice(index,1)
    },
    editarEtapaTratamiento(valor){
      this.editarEtapa = valor;
    },
    agregarNuevo(lista, ptiTrt, etapa){
      let idEtapa = null;
      idEtapa = this.etapasFiltro.find(e=> e.descripcion == etapa);
      lista.push({
        tratamiento: null,
        idTratamiento: null,
        etapa: etapa,
        idEtapa: idEtapa.idEtapaM2,
        cantidad: 1,
        idPtiTratamiento: ptiTrt
      })
    },
    pasarDatos(txOriginal, tx, etapaNombre){
      let idEtapa = null;
      idEtapa = this.etapasFiltro.find(e=> e.descripcion == etapaNombre);
      if (txOriginal.length === 0){
        txOriginal.push({
          tratamiento: null,
          idTratamiento: null,
          etapa: 3,
          cantidad: 1,
          idPtiTratamiento: tx
        })
      }else {
        txOriginal.forEach(t => {
          t.idPtiTratamiento = tx
          t.idEtapa = idEtapa.idEtapaM2
          t.etapa = etapaNombre
        })
      }


    },
    eliminarTratamientoEdicion(lista, item) {
      lista.splice(lista.indexOf(item), 1);
    },
    ponerNombre(lst, idTratamiento){
      this.arrayTratamientoFiltro.forEach(t => {
        if (t.idTratamiento === idTratamiento){
          lst.tratamiento = t.nombre
          lst.precio = t.precio
        }
      })
    },
    quitarReplicas(lista, index){
      lista.splice(index,1)
    },
    dividirColumna(fila, sizeColumnas, sizeOriginal, filaOriginal) {
      if (this.filaCambioTxActual === -1) {
        this.filaCambioTxActual = fila;
      } else if (this.filaCambioTxActual !== fila) {
        this.filaCambioTxActual = fila;
        sizeColumnas.rowspan = sizeOriginal;
        sizeColumnas.filas = fila;
      } else {
        this.filaCambioTxActual = -1
        sizeColumnas.rowspan = sizeOriginal;
        sizeColumnas.filas = filaOriginal;
        return;
      }

      if (sizeOriginal === sizeColumnas.rowspan) {
        const diferencia = sizeColumnas.rowspan - ((fila * 3) + 2);
        sizeColumnas.rowspan -= diferencia;
      } /*else {
        sizeColumnas.rowspan = sizeOriginal;
      }*/

      if (filaOriginal !== sizeColumnas.filas) {
        // sizeColumnas.filas = filaOriginal;
      } else {
        sizeColumnas.filas = fila;
      }
    }
  }
}
</script>

<style scoped>
.contenedorTablaPrecio{
  box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.50);
  border-style: solid;
  border-color: #c9c9c9;
  border-radius: 20px;
  border-width: 1px;
}

.paddingbotones {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 7px;
  padding-left: 7px;
}

.contenedorTablaSinColor {
  padding: 8px;
}

.table.b-table > thead > tr > .table-b-table-default {
  color: #5d5d5d !important;
  background-color: #ffffff !important;
}

.b-table-sticky-header {
  overflow-y: auto;
  max-height: 80vh !important
}

.detalle {
  padding: 0rem;
  vertical-align: top;
  border-top: 0px solid #dee2e6;
}
.letrasChiquitas {
  font-size: unset;
  color: lightslategray;
}
.icon-boton {
  filter: brightness(0) invert(1);
  height: 15px;
  display: block;
}
</style>
